import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UiConfiguration from "../services/UiConfigurationService";

const savedEdgeValue = localStorage.getItem("market-place-saved-edge") || null;

export const uiConfigAll = createAsyncThunk(
  "uiConfiguration/uiConfigAll",
  async () => {
    try {
      let response = await UiConfiguration.uiConfigAll();
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
);

export const uiConfigurationSlice = createSlice({
  name: "uiConfiguration",
  initialState: {
    loading: false,
    error: null,
    data: [],
    theme: {},
    imageServerUrl: "",
    imprintUrl: "",
    privacyUrl: "",
    edge: savedEdgeValue,
    manufacturer: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uiConfigAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(uiConfigAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(uiConfigAll.fulfilled, (state, action) => {
        state.loading = false;
        state.uiConfigData = action.payload;
        state.theme = action?.payload?.content;
        state.imageServerUrl = action?.payload?.content?.imageServerUri;
        state.imprintUrl = action?.payload?.urls?.imprint?.de;
        state.privacyUrl = action?.payload?.urls?.privacy?.de;
        state.edge = savedEdgeValue;
      });
  },
});

export default uiConfigurationSlice.reducer;
